import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import './App.css';

import Home from "./Home";

import Mosaics from "./Mosaics/Mosaics";
import Lizard from "./Mosaics/Lizard";
import Edge from "./Mosaics/Edge";
import Gallery from "./Mosaics/Gallery";
import ContinuousCelebrity from "./Mosaics/ContinuousCelebrity";

import Games from "./Games/Games";
import LegoChess from "./Games/LegoChess";
import Bolbi from "./Games/Bolbi";
import TicTacToe from "./Games/TicTacToe";

import Fractals from "./Fractals/Fractals";

import LegoPlanets from "./LegoPlanets/LegoPlanets";
import LegoEarth from "./LegoPlanets/LegoEarth";
import SmallPlanets from "./LegoPlanets/SmallPlanets";
import LargePlanets from "./LegoPlanets/LargePlanets";

import NeuralStyle from "./NeuralStyle/NeuralStyle"

import MCUActors from "./MCUActors/MCUActors"

function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="*" element={<Home />} />

          <Route path="/Mosaics" element={<Mosaics />} />
          <Route path="/Mosaics/Lizard" element={<Lizard />} />
          <Route path="/Mosaics/Edge" element={<Edge />} />
          <Route path="/Mosaics/Gallery" element={<Gallery />} />
          <Route path="/Mosaics/ContinuousCelebrity" element={<ContinuousCelebrity />} />

          <Route path="/Games" element={<Games />} />
          <Route path="/Games/LegoChess" element={<LegoChess />} />
          <Route path="/Games/Bolbi" element={<Bolbi />} />
          <Route path="/Games/TicTacToe" element={<TicTacToe />} />

          <Route path="/Fractals" element={<Fractals />} />

          <Route path="/LegoPlanets" element={<LegoPlanets />} />
          <Route path="/LegoPlanets/LegoEarth" element={<LegoEarth />} />
          <Route path="/LegoPlanets/SmallPlanets" element={<SmallPlanets />} />
          <Route path="/LegoPlanets/LargePlanets" element={<LargePlanets />} />

          <Route path="/NeuralStyle" element={<NeuralStyle />} />

          <Route path="/MCUActors" element={<MCUActors />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
